import { useMutation, useQueryClient } from '@tanstack/react-query';

import { propertyQueryKeys } from '~/hooks/apis/accommodation/useGetProperty';

import ReservationService from '~/services/ReservationService';

export interface CreateRoomRateParams {
  propertyId: string;
  ratePlanId: string;
  roomTypeId: string;
}

export function useCreateRoomRate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ propertyId, ratePlanId, roomTypeId }: CreateRoomRateParams) =>
      ReservationService.createRoomRate(propertyId, roomTypeId, {
        rate_plan_id: ratePlanId,
        source: 'admin',
      }),
    onSuccess: (_data, { propertyId }) => {
      queryClient.invalidateQueries({ queryKey: propertyQueryKeys.detail(propertyId) });
    },
  });
}
